import React, { createContext, useContext, useState } from 'react';

const OrderHistoryContext = createContext();

export const OrderHistoryProvider = ({ children }) => {
  const [orderHistory, setOrderHistory] = useState(() => {
    // Load from localStorage if available
    const saved = localStorage.getItem('orderHistory');
    return saved ? JSON.parse(saved) : [];
  });

  const addOrderToHistory = (order) => {
    setOrderHistory(prev => {
      const updated = [order, ...prev];
      localStorage.setItem('orderHistory', JSON.stringify(updated));
      return updated;
    });
  };

  const clearOrderHistory = () => {
    setOrderHistory([]);
    localStorage.removeItem('orderHistory');
  };

  return (
    <OrderHistoryContext.Provider value={{
      orderHistory,
      addOrderToHistory,
      clearOrderHistory,
    }}>
      {children}
    </OrderHistoryContext.Provider>
  );
};

export const useOrderHistory = () => useContext(OrderHistoryContext);